import { fmtTL, fmtNum } from "../../lib/format";

const M = (v) => fmtTL(v || 0);
const P = (v) => (v === null || v === undefined ? "—" : `${v > 0 ? "+" : ""}${fmtNum(v, 1)}%`);
const HDR = {
  personnel: ["Hizmet", "Gelir", "Gider", "Fark", "Açıklama"],
  service: ["Hizmet", "Miktar", "Birim", "B.Fiyat WILCO", "B.Fiyat TAŞERON", "Toplam WILCO", "Toplam TAŞERON", "Fark", "Açıklama"],
  atm: ["Hizmet", "Miktar", "Birim", "B.Fiyat WILCO", "Toplam WILCO", "Toplam TAŞERON", "Fark", "Açıklama"],
};

// Proje Maliyet Özeti → PDF bölümleri (PdfTools.getSections): özet (önceki ay karşılaştırmalı) + proje tabloları + açık / tüm detaylar
export function summaryPdfSections(data, { details = "open", openKeys = [] } = {}) {
  if (!data) return [];
  const secs = [];
  const cmp = (r) => [M(r.wilco), M(r.prev_wilco), P(r.wilco_pct), M(r.taseron), M(r.prev_taseron), P(r.taseron_pct), M(r.fark), M(r.prev_fark)];
  secs.push({
    title: `Ana Başlık Özeti — tüm projeler · önceki ay: ${data.prev_period || "—"}`,
    headers: ["Ana Başlık", "Toplam (WILCO)", "Önceki Ay", "Değişim %", "Toplam (TAŞERON)", "Önceki Ay", "Değişim %", "Fark (Kâr/Zarar)", "Önceki Ay Fark"],
    rows: data.categories.map((r) => [r.category_name, ...cmp(r)]),
    footer: [["TOPLAM MALİYET", ...cmp(data.totals)]],
    aligns: ["L", "R", "R", "R", "R", "R", "R", "R", "R"],
  });
  for (const p of data.projects) {
    secs.push({
      title: p.name,
      headers: ["Proje", "Ana Başlık", "Toplam (WILCO)", "Önceki Ay", "Değişim %", "Toplam (TAŞERON)", "Önceki Ay", "Değişim %", "Fark (Kâr/Zarar)", "Açıklama"],
      rows: p.rows.map((r, i) => [i === 0 ? p.name : "", r.category_name, M(r.wilco), M(r.prev_wilco), P(r.wilco_pct), M(r.taseron), M(r.prev_taseron), P(r.taseron_pct), M(r.fark), r.note || r.invoice_no || ""]),
      footer: [["", "TOPLAM MALİYET", M(p.totals.wilco), M(p.totals.prev_wilco), P(p.totals.wilco_pct), M(p.totals.taseron), M(p.totals.prev_taseron), P(p.totals.taseron_pct), M(p.totals.fark), ""]],
      aligns: ["L", "L", "R", "R", "R", "R", "R", "R", "R", "L"],
    });
    for (const r of p.rows) {
      if (details === "none" || (details === "open" && !openKeys.includes(`${p.id}:${r.category_id}`))) continue;
      const d = r.detail, k = r.kind;
      let rows;
      if (k === "personnel") {
        rows = (d.invoice_items || []).map((it) => [`${it.name}${it.correction ? " ✱" : ""}`, M(it.amount), M(0), M(it.amount), it.correction ? "düzeltme farkı" : ""]);
        rows.push([`KESİLEN FATURA TOPLAMI (KDV hariç${d.correction_total ? ` · düzeltme farkı ${M(d.correction_total)} dahil` : ""})`, M(d.invoice_total), M(0), M(d.invoice_total), r.invoice_no || ""]);
        rows.push(...d.services.filter((s) => s.taseron).map((s) => [s.name, M(0), M(s.taseron), M(-s.taseron), "taşeron"]));
        rows.push(...d.cost_items.map((it) => [it.name, M(0), M(it.amount), M(-it.amount), it.desc || ""]));
      } else {
        const svc = k === "service";
        rows = d.services.map((s) => [s.name, fmtNum(s.quantity), s.unit, M(s.unit_wilco), ...(svc ? [M(s.unit_taseron)] : []), M(s.wilco), M(s.taseron), M(s.fark), s.correction ? "düzeltme farkı" : ""]);
        rows.push(...d.cost_items.map((it) => [it.name, "", "", "", ...(svc ? [""] : []), M(0), M(it.amount), M(-it.amount), it.desc || ""]));
      }
      const pad = k === "personnel" ? 0 : k === "service" ? 4 : 3;
      secs.push({
        title: `${p.name} › ${r.category_name} · Hakediş: ${r.invoice_no || "—"} · Taşeron: ${r.sub_invoice_no || "—"} · Dönem: ${data.period}`,
        headers: HDR[k],
        rows,
        footer: [["TOPLAM MALİYET", ...Array(pad).fill(""), M(r.wilco), M(r.taseron), M(r.fark), ""]],
        aligns: HDR[k].map((h, i) => (i === 0 || h === "Birim" || h === "Açıklama" ? "L" : "R")),
      });
    }
  }
  return secs;
}
